import { render, staticRenderFns } from "./activitydetails.vue?vue&type=template&id=1924d690&"
import script from "./activitydetails.vue?vue&type=script&lang=js&"
export * from "./activitydetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports